jQuery(function ($) {
  'use strict';

  /**
   * Функция инициализации лайтбокса для конкретного контейнера
   */
  const initLightbox = (container) => {
    // Проверяем, не инициализирован ли уже лайтбокс (предотвращаем дублирование)
    if ($(container).data('magnificPopup')) {
        return;
    }

    $(container).magnificPopup({
      // Делегируем клики на ссылки, ведущие к изображениям
      delegate: 'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[data-mfp-src]',

      // --- Основные настройки ---
      type: 'image',
      mainClass: 'mfp-fade',
      removalDelay: 300,
      
      // Фиксируем позицию, чтобы лайтбокс не прыгал при скролле страницы
      fixedContentPos: true,
      fixedBgPos: true,

      // --- Галерея ---
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1] // Предзагружаем текущее и следующее изображение
      },

      // --- Кастомизация внешнего вида ---
      image: {
        verticalFit: true, // Автоматически подгоняет высоту
        titleSrc: function (item) {
          // Ищем подпись в .wp-caption-text
          var caption = item.el.closest('.wp-caption').find('.wp-caption-text').text();
          if (caption) {
            return caption.trim();
          }
          // Если не нашли, берем title или alt у самого изображения
          var img = item.el.is('img') ? item.el : item.el.find('img').first();
          if (img.length) {
            return img.attr('title') || img.attr('alt') || '';
          }
          return '';
        },
        markup:
          '<div class="mfp-figure">' +
          '<div class="mfp-close"></div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '<div class="mfp-counter"></div>' +
          '</div>' +
          '</div>',
      },
      
      // --- Коллбэки ---
      callbacks: {
        // При смене изображения в галерее...
        change: function () {
          var el = this.currItem.el; // jQuery-объект текущего элемента (ссылки <a>)

          if (el && el.length) {
            // ...плавно скроллим страницу к этому элементу
            // Используем setTimeout, чтобы избежать конфликтов рендеринга
            setTimeout(function () {
              // Нативный scrollIntoView для лучшей производительности
              el[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center', // Центрируем по вертикали
                inline: 'nearest'
              });
            }, 150);
          }
        },
        // Убираем фокус с элемента, который открыл попап, чтобы избежать автопрокрутки
        beforeClose: function() {
          try { 
            if (this._lastFocusedEl && this._lastFocusedEl.blur) { 
              this._lastFocusedEl.blur(); 
            } 
          } catch(e) {}
          this._lastFocusedEl = null;
        }
      }
    });
  };

  // 1. Инициализируем лайтбокс на контенте, который уже есть на странице
  $('.entry-content').each(function () {
    initLightbox(this);
  });

  // 2. Настраиваем MutationObserver для автоматической инициализации в новых постах
  const contentContainer = document.querySelector('#main, .site-main, main');
  if (contentContainer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              // Ищем .entry-content внутри добавленного узла
              const entryContents = node.querySelectorAll('.entry-content');
              entryContents.forEach(el => initLightbox(el));
              
              // Проверяем, не является ли сам добавленный узел .entry-content
              if (node.classList.contains('entry-content')) {
                initLightbox(node);
              }
            }
          });
        }
      }
    });

    // Начинаем наблюдение
    observer.observe(contentContainer, { childList: true, subtree: true });
  }
});
